import BiotechRounded from "@mui/icons-material/BiotechRounded";
import FolderSharedRounded from "@mui/icons-material/FolderSharedRounded";
import NotificationsActiveRounded from "@mui/icons-material/NotificationsActiveRounded";
import ShowChartRounded from "@mui/icons-material/ShowChartRounded";
import SmartToyRounded from "@mui/icons-material/SmartToyRounded";
import TimelineRounded from "@mui/icons-material/TimelineRounded";
import { motion } from "framer-motion";

const capabilities = [
  {
    title: "Smart Document Parsing",
    description:
      "Upload PDFs, images, or scanned reports. Our AI extracts structured data from any format with 99.2% accuracy.",
    Icon: BiotechRounded
  },
  {
    title: "Longitudinal Timeline",
    description:
      "See every diagnosis, prescription, test result, and procedure plotted chronologically on your personal health timeline.",
    Icon: TimelineRounded
  },
  {
    title: "Lab Trend Analysis",
    description:
      "Track biomarkers like HbA1c, cholesterol, and CBC over time with visual trends and reference range overlays.",
    Icon: ShowChartRounded
  },
  {
    title: "AI Health Summaries",
    description:
      "Generate plain-language summaries of complex medical records ready to share with specialists or family members.",
    Icon: SmartToyRounded
  },
  {
    title: "Proactive Alerts",
    description:
      "Get notified about abnormal values, medication interactions, upcoming screenings, and preventive care reminders.",
    Icon: NotificationsActiveRounded
  },
  {
    title: "EHR Integration",
    description:
      "Seamlessly connect with Epic, Cerner, Allscripts, and 150+ hospital systems via HL7 FHIR standards.",
    Icon: FolderSharedRounded
  }
];

export default function FeaturesSection() {
  return (
    <section id="capabilities" className="mx-auto max-w-7xl px-6 py-20 md:px-10">
      <div className="mx-auto mb-14 max-w-3xl text-center">
        <span className="inline-block rounded-full bg-sky-100 px-4 py-1 text-xs font-semibold uppercase tracking-wide text-sky-800">
          Core Capabilities
        </span>
        <h2 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 md:text-4xl">
          Everything You Need for Complete Health Clarity
        </h2>
        <p className="mt-4 text-lg text-gray-600">
          From raw lab reports to structured insights — HealthTimeline AI handles every layer of your medical data
          lifecycle.
        </p>
      </div>

      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {capabilities.map((item, index) => (
          <motion.article
            key={item.title}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.06 }}
            whileHover={{ y: -3 }}
            className="rounded-2xl border border-gray-200/90 bg-white p-6 shadow-sm transition-shadow hover:shadow-md"
          >
            <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-slate-100 text-slate-700">
              <item.Icon sx={{ fontSize: 26 }} />
            </div>
            <h3 className="text-lg font-semibold text-gray-900">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-600">{item.description}</p>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
